import { Map, List, merge } from 'immutable';

import createTypedReducer from '../createTypedReducer';
import * as checkSheetActions from './action';
import { CHANGE_CLIENT, CLEAR } from '../authentication/action';

export const initialState = Map({
  checkSheets: Map(),
});

function resetState (state) {
  return state.withMutations((nextState) =>
    nextState.set('checkSheets', Map())
  );
}

export const checkSheetReducer = createTypedReducer(initialState, {
  [checkSheetActions.FETCH_CHECK_SHEET_TASKS] (state) {
    return state.withMutations((nextState) =>
      nextState.setIn(['checkSheets', 'tasks', 'loading'], true)
    );
  },
  [checkSheetActions.FETCH_CHECK_SHEET_TASKS_SUCCESS] (state, action) {
    return state.withMutations((nextState) =>
      nextState.setIn(['checkSheets', 'tasks', action.checkSheetType], action.tasks)
        .setIn(['checkSheets', 'tasks', 'loading'], false)
    );
  },
  [checkSheetActions.FETCH_CHECK_SHEET_TASKS_FAILED] (state) {
    return state.withMutations((nextState) =>
      nextState.setIn(['checkSheets', 'tasks', 'loading'], false)
    );
  },

  [checkSheetActions.UPDATE_CHECK_SHEET_TYPE_SUCCESS] (state, action) {
    return state.withMutations((nextState) => {
      nextState.setIn(['checkSheets', 'data', action.checkSheetId, 'record', 'check_sheet_type'], action.checkSheetType);
    });
  },
  [checkSheetActions.FETCH_CHECK_SHEET] (state) {
    return state.withMutations((nextState) => {
      nextState.setIn(['checkSheets', 'loading'], true);
    });
  },
  [checkSheetActions.FETCH_CHECK_SHEETS_SUCCESS] (state, action) {
    return state.withMutations((nextState) => {
      const fetchDate = new Date();
      action.data.map((checkSheet) => {
        nextState.setIn(['checkSheets', 'data', checkSheet.get('id')], {
          record: checkSheet,
          lastFetch: fetchDate,
        });
      });
    });
  },

  [checkSheetActions.FETCH_CHECK_SHEET_SUCCESS] (state, action) {
    return state.withMutations((nextState) => {
      const fetchDate = new Date();
      const curr = nextState.getIn(['checkSheets', 'data', action.checkSheetId, 'record']);
      const combinedRecord = merge(Map(curr), action.data);
      nextState.setIn(['checkSheets', 'data', action.checkSheetId], {
        record: combinedRecord,
        lastFetch: fetchDate,
      });
      nextState.setIn(['checkSheets', 'loading'], false);
    });
  },
  [checkSheetActions.FETCH_CHECK_SHEET_FAILED] (state) {
    return state.withMutations((nextState) => {
      nextState.setIn(['checkSheets', 'loading'], false);
    });
  },
  [checkSheetActions.SAVE_CHECK_SHEET] (state, action) {
    return state.withMutations((nextState) => {
      nextState.setIn(['checkSheets', 'submit',  action.checkSheetType, 'loading'], true);
    });
  },
  [checkSheetActions.SAVE_CHECK_SHEET_SUCCESS] (state, action) {
    return state.withMutations((nextState) => {
      nextState.setIn(['checkSheets', 'submit', action.checkSheetType, 'loading'], false);
      nextState.setIn(['checkSheets', 'submit', action.checkSheetType, 'open'], false);
      const fetchDate = new Date();

      nextState.setIn(['checkSheets', 'data', action.data.get('id')], {
        record: action.data,
        lastFetch: fetchDate,
      });
      // Signal the commissioning list to refetch (mirrors lastLinkSuccess for device linking)
      nextState.updateIn(['checkSheets', 'fieldReports', 'lastSaveSuccess'], (n = 0) => n + 1);

    });
  },
  [checkSheetActions.SAVE_CHECK_SHEET_FAILED] (state, action) {
    return state.withMutations((nextState) => {
      nextState.setIn(['checkSheets', 'submit', action.checkSheetType, 'loading'], false);

    });
  },
  [checkSheetActions.OPEN_CHECK_SHEET] (state, action) {
    return state.withMutations((nextState) => {
      nextState.setIn(['checkSheets', 'submit', action.checkSheetType, 'loading'], false);
      nextState.setIn(['checkSheets', 'submit', action.checkSheetType, 'open'], true);
    });
  },
  [checkSheetActions.CLOSE_CHECK_SHEET] (state, action) {
    return state.withMutations((nextState) => {
      nextState.setIn(['checkSheets', 'submit', action.checkSheetType, 'loading'], false);
      nextState.setIn(['checkSheets', 'submit', action.checkSheetType, 'open'], false);
    });
  },
  [checkSheetActions.UPDATE_CHECK_SHEET_SUCCESS] (state, action) {
    return state.withMutations((nextState) => {
      nextState.setIn(['checkSheets', 'submit', action.checkSheetType, 'loading'], false);
      nextState.setIn(['checkSheets', 'submit', action.checkSheetType, 'open'], false);
      const fetchDate = new Date();

      nextState.setIn(['checkSheets', 'data', action.data.get('id')], {
        record: action.data,
        lastFetch: fetchDate,
      });
      // Signal the commissioning list to refetch (mirrors lastLinkSuccess for device linking)
      nextState.updateIn(['checkSheets', 'fieldReports', 'lastSaveSuccess'], (n = 0) => n + 1);

    });
  },
  [checkSheetActions.UPDATE_CHECK_SHEET_FAILED] (state, action) {
    return state.withMutations((nextState) => {
      nextState.setIn(['checkSheets', 'submit', action.checkSheetType, 'loading'], false);

    });
  },





  [checkSheetActions.FETCH_FIELD_REPORTS] (state) {
    return state.withMutations((nextState) => {
      nextState.setIn(['checkSheets', 'fieldReports', 'loading'], true);
    });
  },
  [checkSheetActions.FETCH_FIELD_REPORTS_SUCCESS] (state, action) {
    return state.withMutations((nextState) => {
      const fetchDate = new Date();
      const ids = action.data.map((report) => report.get('id'));
      action.data.map((report) => {
        const id = report.get('id');
        const existing = nextState.getIn(['checkSheets', 'data', id, 'record']);
        const combinedRecord = existing ? merge(Map(existing), report) : report;
        nextState.setIn(['checkSheets', 'data', id], {
          record: combinedRecord,
          lastFetch: fetchDate,
        });
      });
      nextState.setIn(['checkSheets', 'fieldReports', 'ids'], List(ids));
      nextState.setIn(['checkSheets', 'fieldReports', 'total'], action.total);
      nextState.setIn(['checkSheets', 'fieldReports', 'totalPages'], action.totalPages);
      nextState.setIn(['checkSheets', 'fieldReports', 'loading'], false);
    });
  },
  [checkSheetActions.FETCH_FIELD_REPORTS_FAILED] (state) {
    return state.withMutations((nextState) => {
      nextState.setIn(['checkSheets', 'fieldReports', 'loading'], false);
    });
  },

  [checkSheetActions.LINK_DEVICE_TO_CHECK_SHEET_SUCCESS] (state, action) {
    return state.withMutations((nextState) => {
      nextState.setIn(['checkSheets', 'data', action.reportId, 'record', 'device_id'], action.deviceId);
      nextState.updateIn(['checkSheets', 'fieldReports', 'lastLinkSuccess'], (n = 0) => n + 1);
    });
  },

  [checkSheetActions.UPDATE_DEVICE_LINK_SUCCESS] (state, action) {
    return state.withMutations((nextState) => {
      nextState.setIn(['checkSheets', 'data', action.reportId, 'record', 'device_id'], action.deviceId);
      nextState.updateIn(['checkSheets', 'fieldReports', 'lastLinkSuccess'], (n = 0) => n + 1);
    });
  },

  [checkSheetActions.DOWNLOAD_FIELD_REPORT_PDF] (state, action) {
    return state.withMutations((nextState) => {
      nextState.setIn(['checkSheets', 'pdf', 'individual', action.reportId, 'loading'], true);
    });
  },
  [checkSheetActions.DOWNLOAD_FIELD_REPORT_PDF_SUCCESS] (state, action) {
    return state.withMutations((nextState) => {
      nextState.deleteIn(['checkSheets', 'pdf', 'individual', action.reportId]);
    });
  },
  [checkSheetActions.DOWNLOAD_FIELD_REPORT_PDF_FAILED] (state, action) {
    return state.withMutations((nextState) => {
      nextState.deleteIn(['checkSheets', 'pdf', 'individual', action.reportId]);
    });
  },

  [checkSheetActions.DOWNLOAD_FIELD_REPORT_SUMMARY_PDF] (state) {
    return state.withMutations((nextState) => {
      nextState.setIn(['checkSheets', 'pdf', 'summary', 'loading'], true);
    });
  },
  [checkSheetActions.DOWNLOAD_FIELD_REPORT_SUMMARY_PDF_SUCCESS] (state) {
    return state.withMutations((nextState) => {
      nextState.setIn(['checkSheets', 'pdf', 'summary', 'loading'], false);
    });
  },
  [checkSheetActions.DOWNLOAD_FIELD_REPORT_SUMMARY_PDF_FAILED] (state) {
    return state.withMutations((nextState) => {
      nextState.setIn(['checkSheets', 'pdf', 'summary', 'loading'], false);
    });
  },

  [checkSheetActions.DOWNLOAD_BULK_FIELD_REPORT_PDF] (state) {
    return state.withMutations((nextState) => {
      nextState.setIn(['checkSheets', 'pdf', 'bulk', 'loading'], true);
    });
  },
  [checkSheetActions.DOWNLOAD_BULK_FIELD_REPORT_PDF_SUCCESS] (state) {
    return state.withMutations((nextState) => {
      nextState.setIn(['checkSheets', 'pdf', 'bulk', 'loading'], false);
    });
  },
  [checkSheetActions.DOWNLOAD_BULK_FIELD_REPORT_PDF_FAILED] (state) {
    return state.withMutations((nextState) => {
      nextState.setIn(['checkSheets', 'pdf', 'bulk', 'loading'], false);
    });
  },

  [checkSheetActions.FETCH_REPORTS_CSV_EXPORT] (state) {
    return state.withMutations((nextState) => {
      nextState.setIn(['exportReports', 'loading'], true);
    });
  },
  [checkSheetActions.FETCH_REPORTS_CSV_EXPORT_SUCCESS] (state) {
    return state.withMutations((nextState) => {
      nextState.setIn(['exportReports', 'loading'], false);
    });
  },
  [checkSheetActions.FETCH_REPORTS_CSV_EXPORT_FAILED] (state) {
    return state.withMutations((nextState) => {
      nextState.setIn(['exportReports', 'loading'], false);
    });
  },

  [CLEAR] (state) {
    return resetState(state);
  },

  [CHANGE_CLIENT] (state) {
    return resetState(state);
  }
});

export default checkSheetReducer;
